import React from 'react';

import { ProcessCreateAddCustomerTableRow } from '@/views/processesCreate/components/ProcessCreateAddCustomerTableRow.comp.tsx';

type Props = Omit<
  React.ComponentProps<typeof ProcessCreateAddCustomerTableRow>,
  'onlyProcessCustomers'
>;

/** A customer to choose as the customer of a process: only an ACTIVE customer can be chosen. */
export const ProcessCustomerPickerTableRow = (props: Props) => (
  <ProcessCreateAddCustomerTableRow {...props} onlyProcessCustomers />
);
